import React, { useState, useEffect } from "react";
import { ScalingContainer } from "../../../AppStyled";

import { Volume } from "./SettingsStyled";
import { SettingsDiv } from "./SettingsStyled";
import { Header } from "../../../AppStyled";

import ToggleSwitch from "./ToggleSwitch";
import useSound from "use-sound";
import goForward from "../../../audio/goForward.mp3";

export default function Settings({
  userSettings,
  saveUserSettings,
  handleAbove,
  isClickable,
  unBlur,
  scaleDown,
  h,
}) {
  const [music, setmusic] = useState(userSettings.music);
  const [sound, setsound] = useState(userSettings.sound);
  const [volume, setvolume] = useState(userSettings.volume);
  useEffect(() => {
    setmusic(userSettings.music);
    setsound(userSettings.sound);
    setvolume(userSettings.volume);
  }, [userSettings]);
  const [goForwardSfx] = useSound(goForward, { volume });
  const handleSavingSettings = (arr) => saveUserSettings(arr);

  return (
    <SettingsDiv className="SettingsDiv" unBlur={unBlur} scaleDown={scaleDown}>
      <ScalingContainer className="ScalingContainer" h={h}>
        <Header
          name={"SETTINGS"}
          handleAbove={handleAbove}
          userSettings={userSettings}
        />
        <h3
          style={
            isClickable ? { pointerEvents: "auto" } : { pointerEvents: "none" }
          }
          onClick={() => {
            if (sound) goForwardSfx();
            handleAbove("provFair");
          }}
        >
          Provably Fair
        </h3>
        <h3
          onClick={() => {
            if (sound) goForwardSfx();

            handleAbove("gameRules");
          }}
        >
          Game Rules
        </h3>
        <h3
          onClick={() => {
            if (sound) goForwardSfx();

            handleAbove("history");
          }}
        >
          History
        </h3>
        <ToggleSwitch
          name={"Music"}
          isOn={music}
          sound={sound}
          save={() => handleSavingSettings([!music, sound, volume])}
        />

        <ToggleSwitch
          name={"Sound"}
          isOn={sound}
          sound={sound}
          save={() => handleSavingSettings([music, !sound, volume])}
        />

        <Volume
          saveUserSetting={(v) => handleSavingSettings([music, sound, v])}
          value={volume}
        />
      </ScalingContainer>
    </SettingsDiv>
  );
}
